import React from 'react'
import { Withdrawal } from 'src/core/models'
import WithdrawalDetailsButton from './WithdrawalDetails/WithdrawalDetailsButton'
import WithdrawalValidateButton from './WithdrawalValidateButton/WithdrawalValidateButton'
import WithdrawalCancelButton from './WithdrawalCancelButton/WithdrawalCancelButton'

interface WithdrawalActionsColumnProps { withdrawal: Withdrawal }

const WithdrawalActionsColumn: React.FC<WithdrawalActionsColumnProps> = ({ withdrawal }) => {
  return (
    <div className='centered'>
      {/* Details */}
      <WithdrawalDetailsButton withdrawal={withdrawal} />
      {/* Validate */}
      <WithdrawalValidateButton withdrawal={withdrawal} />
      {/* Cancel */}
      <WithdrawalCancelButton withdrawal={withdrawal} />
    </div>
  )
}

export default WithdrawalActionsColumn
